$('.tabs .tab-bar a').on('click', function (e) {
    e.preventDefault();
    $(this).tab('show');
});

$('#lesson-plan').on('click', function (e) {
    e.preventDefault();
    var self = $(this),
        container = $('.reveal');
    if (self.hasClass('active')) {
        container.slideUp();
        self.removeClass('active');
        self.text('Show full lesson plan');
    } else {
        container.slideDown();
        self.addClass('active');
        self.text('Hide full lesson plan');
    }
});
